"use client";
import React, { useState, useEffect } from 'react';
import { useMediaQuery, useTheme, Button, IconButton, Box } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import FiltersPopover from './FiltersPopover';
import SortPopover from './SortPopover';
import { useFilters } from 'app/providers/filters-provider';
import { useAuth } from 'app/providers/auth-provider'

const DealsHeader = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const [anchorEl, setAnchorEl] = useState(null);
    const {
        collection,
        DEFAULT_COLLECTION
    } = useFilters();
    const filtersOpen = Boolean(anchorEl);

    const authProvider = useAuth()

    const [user, setUser] = useState(null)

    const isFeatureCategory = collection.value && collection.value === DEFAULT_COLLECTION.value;

    const shouldShowBreadcrumb = collection && collection !== DEFAULT_COLLECTION.value;

    const handleFiltersOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleFiltersClose = () => {
        setAnchorEl(null);
    };

    useEffect(() => {
        if (authProvider && (authProvider.user && authProvider.user?.email)) {
            setUser(authProvider.user)
        }
    }, [authProvider])

    return (
        <>
            <div className="deals-header" style={{ marginTop: '20px' }}>
                <div className="deals-header__top" style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    width: '100%'
                }}>
                    <h1 className="deals-header__title" style={{ fontSize: '35px', margin: 0 }}>Deals</h1>

                    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                        {/* Sort Button - Only show if not featured category */}
                        {!isFeatureCategory && (
                            <SortPopover />
                        )}

                        {/* Filters Button */}
                        {isMobile ? (
                            <IconButton
                                onClick={handleFiltersOpen}
                                sx={{
                                    bgcolor: 'var(--theme-dark, #2B4D59)',
                                    color: '#fff',
                                    '&:hover': {
                                        bgcolor: 'rgba(43, 77, 89, 0.8)',
                                    },
                                    borderRadius: '8px',
                                    p: 1.5
                                }}
                            >
                                <FilterListIcon />
                            </IconButton>
                        ) : (
                            <Button
                                variant="contained"
                                startIcon={<FilterListIcon />}
                                onClick={handleFiltersOpen}
                                sx={{
                                    bgcolor: 'var(--theme-dark, #2B4D59)',
                                    color: '#fff',
                                    '&:hover': {
                                        bgcolor: 'rgba(43, 77, 89, 0.8)',
                                    },
                                    borderRadius: '8px',
                                    px: 2,
                                    py: 1,
                                    textTransform: 'none',
                                    fontWeight: 600,
                                    fontSize: '14px'
                                }}
                            >
                                Filters
                            </Button>
                        )}
                    </Box>
                </div>
                {shouldShowBreadcrumb && (
                    <div className="deals-header__breadcrumb" style={{ marginBottom: '10px', fontSize: '16px', fontWeight: '600', color: '#666', textAlign: 'left' }}>
                        <span style={{ color: 'var(--theme-dark)' }}>Home /</span> <span style={{ color: 'var(--second-color)' }}>
                            {(user?.creatorId && collection.label === 'Featured Products') ? 'Your Products' : collection.label}
                        </span>
                    </div>
                )}
            </div>

            {/* Filters Popover */}
            <FiltersPopover
                open={filtersOpen}
                anchorEl={anchorEl}
                onClose={handleFiltersClose}
                hideSort={isFeatureCategory}
            />
        </>
    );
};

export default DealsHeader; 